export const SystemAdmin = "SystemAdmin";
export const AgencyAdmin = "AgencyAdmin";
export const ClientAdmin = "ClientAdmin";
export const ClientViewer = "ClientViewer";
export const ClientPMRole = "ClientPM";
export const Subcontractor = "Subcontractor";
export const AddUser = "AddUser";

const GROUPS = {
  SystemAdmin,
  AgencyAdmin,
  ClientAdmin,
  ClientViewer,
  ClientPMRole,
  Subcontractor,
  AddUser,
}

export const GROUPS_CAN_ADD_USER = [
  SystemAdmin,
  AgencyAdmin,
  ClientAdmin,
]

export default GROUPS;
